// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import VueToastr from '@deveodk/vue-toastr'
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css'
import'./components/inputs/Index.js'
import VueEvents from 'vue-events'
import { client as axios } from './api/backend'
import utils from './helpers/Utils.js'

import 'select2/dist/css/select2.css';
import 'select2'; 
import 'whatwg-fetch';

window.$ = window.jQuery = require('jquery')

Vue.config.productionTip = false;

Vue.prototype.$utils = utils;
Vue.prototype.$http = axios;

Vue.use(VueEvents)
Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaulttitle: 'Atenção',
  defaultTimeout: 10000
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  data () {
    return {
      baseUrl: process.env.BASE_URL
    }
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js